import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
    selector: 'irb-component-securities-delete-cell',
    template: `
        <div >
          <div class="btn-action-close-delete" calltoaction [calltoactionTemplate]="irbComponentSecDeleteCell"></div>
          <ng-template #irbComponentSecDeleteCell>
            <div class="block">{{params.message}}</div>
            @if (params.note) {
              <div class="block">{{params.note}}</div>
            }
            <div class="buttonSet center">
              <div style="margin-bottom: 4px;">
                <button pButton label="Extract" (click)="extract()"></button>
              </div>
              <div style="margin-bottom: 4px;">
                <button pButton label="Delete" (click)="delete()"></button>
              </div>
              <div>
                <button pButton label="Cancel" (click)="cancel()" class="ui-button-secondary"></button>
              </div>
            </div>
          </ng-template>
        </div>
        `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComponentSecuritiesDeleteCellComponent {
    params: any;

    agInit(params: any): void {
        this.params = params;
    }

    cancel() {
        if(typeof this.params.cancel !== "undefined") {
            this.params.cancel();
        }
    }

    extract() {
        if(typeof this.params.extract !== "undefined") {
            this.params.extract(this.params.data);
        }
    }

    delete() {
        if(typeof this.params.delete !== "undefined") {
            this.params.delete(this.params.data);
        }
    }
}
